import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setEmailCoupon } from 'State/PromoCode/PromoCodeActions';
import { autoApplyEmailCoupon } from 'State/PromoCode/PromoCodeActions';

const EMAIL_COUPON_PARAM = 'promoCoupon';
const AUTO_APPLY_COUPON = 'applyCoupon';

export function useEmailCoupon(couponParam = EMAIL_COUPON_PARAM, autoApply = AUTO_APPLY_COUPON) {
  const [couponCode, setCouponCode] = useState('');
  const { search = '' } = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    const searchQuery = new URLSearchParams(search);
    const couponCode = searchQuery.get(couponParam) || null;
    const isAutoApply = searchQuery.get(autoApply) === 'true';
    if (couponCode) {
      const code = couponCode.toUpperCase();
      dispatch(setEmailCoupon(code));
      setCouponCode(code);
    }
    if (couponCode && isAutoApply) {
      dispatch(autoApplyEmailCoupon(isAutoApply));
    }
  }, [dispatch, search, couponParam, autoApply]);
  return couponCode;
}
